export default function Cursor() {
	return <div className=""></div>
}